import React, { useState } from 'react'
import { toast } from 'react-toastify'
interface Iprops {
  createTicketModalClosed: any
}

const ModalFlow: React.FC<Iprops> = ({ createTicketModalClosed }) => {
  // State to manage form inputs
  const [formData, setFormData] = useState({
    title: '',
    kpi: ''
  })

  // Handle input change
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value
    })
  }

  // Handle form submission
  const handleSubmit = (e: any) => {
    e.preventDefault()
    createTicketModalClosed()
    toast.success('Information Added Successfuly')
    // Process form data here (e.g., send to an API, validate, etc.)
    console.log('Form submitted:', formData)
  }

  return (
    <div>
      <div className='container' style={{ padding: '0px', marginTop: '20px' }}>
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='name'>Title</label>
            <input
              type='text'
              className='form-control'
              id='name'
              name='title'
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>
          <div className='form-group'>
            <label htmlFor='KPI'>KPI Measurement Unit</label>
            <input
              type='text'
              className='form-control'
              id='kpi'
              name='kpi'
              value={formData.kpi}
              onChange={handleChange}
              required
            />
          </div>
          <div
            style={{
              display: 'flex',
              gap: '20px',
              marginTop: '20px',
              width: '100%',
              justifyContent: 'end'
            }}
          >
            <button type='button' className='btn btn-secondary' onClick={createTicketModalClosed}>
              Cancel
            </button>
            <button type='submit' className='btn btn-primary'>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ModalFlow
